import { createContext } from 'react';

import { TCurrentUserTeamDto, TTeamDto } from '@app-velocity/av-api-v2';

export type TeamAdminContextType = {
  team: TTeamDto;
  userTeam: TCurrentUserTeamDto;
  workspaceId: string;
};

export const TeamAdminContext = createContext<TeamAdminContextType>({
  team: {},
  userTeam: {},
  workspaceId: '',
});
